// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"31d6cfe0","606":"5d3bd312"}[chunkId] + ".chunk.css";
};